type BrandedCase = {
  client?: { code?: string } | null;
  organization?: { id?: string } | null;
};

/** Historical branding follows the case's client, not the current viewer. */
export const isGumCase = (caseData?: BrandedCase | null): boolean =>
  caseData?.client ? caseData.client.code === 'gum_virtual_care' : caseData?.organization?.id === 'gum-virtual-care';
